import Swiper, { Navigation } from "swiper"
Swiper.use([ Navigation ])

export default class FSlider {

  constructor (el) {
    this.el = el
    this.slider = null
    this.next = this.el.closest('.feedbacks').querySelector('.swiper-navigation__btn--next')
    this.prev = this.el.closest('.feedbacks').querySelector('.swiper-navigation__btn--prev')
    this.nextMobile = this.el.querySelector('.swiper-btn--next')
    this.prevMobile = this.el.querySelector('.swiper-btn--prev')
    this.isMobile = false
  }

  init () {
    this.initSlider()
    this.initEvents()
  }

  updateSlider () {
    if (window.innerWidth < 768) {
      if (this.isMobile) return;
      this.isMobile = true
      this.destroySlider()
      this.initSlider()
    } else {
      if (!this.isMobile) return;
      this.isMobile = false
      this.destroySlider()
      this.initSlider()
    }
  }

  initEvents () {
    window.addEventListener('resize', () => this.updateSlider())
  }

  initSlider () {
    this.slider = new Swiper(this.el, {
      slidesPerView: 1,
      spaceBetween: 32,
      watchOverflow: true,
      watchSlidesProgress: true,
      centeredSlides: true,
      observer: true,
      navigation: {
        prevEl: window.innerWidth < 768 ? this.prevMobile : this.prev,
        nextEl: window.innerWidth < 768 ? this.nextMobile : this.next
      },
      breakpoints: {
        1439: {
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 40
        },
        1025: {
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 24
        },
        768: {
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 20
        }
      }
    })
  }

  destroySlider () {
    if (this.slider) {
      this.slider.destroy()
      this.slider = null
    }
  }

}
